import { GenericForm } from '@neo/blocks/forms/generic-form'
import type { CustomCompType } from '@neo/blocks/forms/types'
import { Button, ButtonWithLoader } from '@neo/index'
import { DialogFooter } from '@neo/primitives/dialog'
import { AudioUploadField } from '../components/audio-upload-field'
import { voiceCloneDefaultValues, voiceCloneFields, voiceCloneSchema } from '../custom-voice.config'
import type { VoiceCloneFormValues } from '../custom-voice.types'

interface VoiceCloneTabProps {
  onCancel: () => void
  onSubmit: (values: VoiceCloneFormValues) => void
  isSubmitting?: boolean
}

export const VoiceCloneTab = ({ onCancel, onSubmit, isSubmitting = false }: VoiceCloneTabProps) => {
  return (
    <div className="pt-4">
      <GenericForm<VoiceCloneFormValues>
        fields={[
          ...voiceCloneFields,
          {
            name: 'audioFile',
            type: 'custom',
            zodValidation: voiceCloneSchema.shape.audioFile,
            component: AudioUploadField as CustomCompType<VoiceCloneFormValues>,
            className: 'col-span-2',
            eventDataExtractor: (data) => data as File | null,
          },
          {
            name: 'consentConfirmed',
            componentType: 'checkbox',
            zodValidation: voiceCloneSchema.shape.consentConfirmed,
            className: 'col-span-2 mt-2',
            inputProps: {
              label: (
                <span className="text-s-400">
                  I confirm that I have the right to use this voice and that it complies with
                  ElevenLabs terms of service
                </span>
              ),
              'data-testid': 'checkbox-consent',
            },
          },
        ]}
        defaultValues={voiceCloneDefaultValues}
        onSubmit={onSubmit}
        includeSubmitButton={false}
        id="voice-clone-form"
        className="grid grid-cols-2 gap-4"
      />
      <DialogFooter className="mt-6 flex flex-row sm:justify-between">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
          data-testid="button-cancel-voice-clone"
        >
          Cancel
        </Button>
        <ButtonWithLoader
          form="voice-clone-form"
          type="submit"
          loading={isSubmitting}
          disabled={isSubmitting}
          data-testid="button-add-voice-clone"
        >
          Add Voice
        </ButtonWithLoader>
      </DialogFooter>
    </div>
  )
}
